import React, {Fragment, useCallback, useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toaster } from "@/shared/libs/toaster";
// import { Button, Classes } from "@blueprintjs/core";
// import { Form, Input, InputPassword } from "@/shared/components/Form";
import {Modal, Form, Input, Button, message, Space} from "antd";
import { useForm } from "@/shared/libs/react-hook-form";
// import { request } from "@/shared/libs/request";
// import { setToken } from "@/shared/libs/request";
import {bindOpenidToErpUser, bindSchema, bindUserDTO, loginSchema} from "@/shared/api/system/auth/login";
import {token as tokenStorage} from "@/shared/utils/storage";
import {LoadingOutlined} from "@ant-design/icons";
import {InputPassword} from "@/shared/components/Form";
import {IconName} from "@blueprintjs/core";
// import {Modal} from "antd"; // 绑定表单校验规则


// 1. 定义组件Props的TypeScript类型
interface WechatBindModalProps {
    /** 弹窗显示/隐藏状态 */
    visible: boolean;
    /** 关闭弹窗的回调函数 */
    onClose: () => void;
    /** 微信openid（从父组件传入） */
    openid: string;
    /** 绑定成功后的回调函数（可选） */
    onBindSuccess?: (token:string) => void;
    /** 弹窗标题（可选，默认值） */
    title?: string;
    /** 弹窗提示文案（可选，默认值） */
    tipText?: string;
}

// 2. 定义表单字段类型
interface BindFormFields {
    // openid:string;
    /** ERP工号/登录账号 */
    empNo: string;
    /** ERP登录密码 */
    password: string;
}


/**
 * ERP账号绑定弹窗组件
 * @param {boolean} visible - 弹窗显示/隐藏
 * @param {Function} onClose - 关闭弹窗回调
 * @param {string} openid - 微信openid（从父组件传入）
 * @param {Function} onBindSuccess - 绑定成功后的回调（如刷新登录状态）
 */
const WechatBindModal = ({
     visible,
     onClose,
     openid,
     onBindSuccess,
     title = "微信绑定ERP账号",
     tipText = "输入你的ERP工号和登录密码，完成微信与ERP账号绑定，后续可直接扫码登录"
}:WechatBindModalProps) => {
    // 1. 状态定义
    const [isBinding, setIsBinding] = useState(false); // 绑定加载状态
    const [submitLock, setSubmitLock] = useState(false); // 提交锁（防重复提交）
    const [form] = Form.useForm<BindFormFields>(); // 指定表单字段类型

    // 2. 弹窗关闭时重置表单
    useEffect(() => {
        if (!visible) {
            form.resetFields(); // 清空表单
            setIsBinding(false); // 重置加载状态
            setSubmitLock(false); // 重置提交锁
        }
    }, [visible, form]);

    // 3. 校验openid有效性
    useEffect(() => {
        if (visible && !openid) {
            message.error("绑定参数异常，请重新扫码", 2);
            onClose(); // 关闭弹窗
        }
    }, [visible, openid, onClose]);

    // 4. 绑定提交核心逻辑
    const handleBindSubmit = useCallback(
        async (values:any) => {
            // 双重防护：加载中/提交锁 均拦截
            if (isBinding || submitLock || !openid) return;;

            try {
                setIsBinding(true);
                // 构造绑定请求参数
                const bindRequest = {
                    openid: openid,
                    empNo: values.empNo, // ERP工号
                    password: values.password, // ERP密码
                };
                setSubmitLock(true); // 加提交锁
                // 调用后端绑定接口
                console.log("调用后端接口绑定参数:",bindRequest);
                const response = await bindOpenidToErpUser(bindRequest);
                console.log("调用后端接口绑定参数返回结果:",response);
                // const result = response.data;
                    // 绑定成功：存储令牌 + 提示 + 关闭弹窗 + 执行成功回调
                    // const { jwtToken } = result;
                    // setToken(jwtToken); // 存储JWT令牌到本地
                    // message.success("绑定成功！即将自动登录", 2);
                    // tokenStorage.setToken(result?.token??"");
                    onClose(); // 关闭弹窗
                    if (onBindSuccess) {
                        onBindSuccess(response?.token??""); // 通知父组件绑定成功（如刷新页面/跳转首页）
                    } else {
                        // 绑定失败：显示错误提示
                        message.error("绑定失败，请检查账号密码", 3);
                    }
            } catch (error) {
                // 网络异常处理
                console.error("ERP账号绑定失败：", error);
                message.error("网络异常，绑定请求失败，请稍后重试", 3);
            } finally {
                setIsBinding(false); // 重置加载状态
                setSubmitLock(false);//解提交锁
            }
        },
        [openid, isBinding, onClose, onBindSuccess]
    );

    // 5. 取消绑定（关闭弹窗）
    const handleCancel = useCallback(() => {
        if (!isBinding) {
            onClose();
        }
    }, [isBinding, onClose]);

    // 6. 弹窗渲染
    return (
        <Modal
            key="wechat-bind-modal" // 优化：添加唯一key
            title={title} // 优化：自定义标题
            open={visible}
            onCancel={handleCancel}
            maskClosable={false} // 点击遮罩层不关闭（防止误操作）
            closable={!isBinding && !submitLock} // 加载/提交中隐藏关闭按钮
            footer={null} // 自定义底部按钮，关闭默认footer
            width={450} // 弹窗宽度
            destroyOnClose={true} // 关闭弹窗时销毁组件，清空状态
        >
            {/* 弹窗提示说明 */}
            <div key="modal-tip" style={{ marginBottom: 16, color: "#666", fontSize: 14 }}>
                {tipText} {/* 优化：自定义提示文案 */}
            </div>

            {/* 绑定表单 */}
            <Form
                key="bind-form"
                form={form}
                onFinish={handleBindSubmit}
                layout="vertical"
                disabled={isBinding || submitLock}
            >
                {/* ERP工号输入项 */}
                <Form.Item
                    key="form-empNo"
                    name="empNo"
                    label="ERP登录账号（工号）"
                    rules={[
                        { required: true, message: "请输入ERP工号" },
                        { min: 3, message: "工号长度不能少于3位" },
                        { pattern: /^[a-zA-Z0-9_-]+$/, message: "工号仅支持字母、数字、下划线" },
                    ]}
                    // 修复：禁用状态下不显示校验图标
                    hasFeedback={!isBinding && !submitLock}
                >
                    <Input
                        placeholder="请输入ERP工号（如：EMP001、zhangsan）"
                        // size="large"
                        disabled={isBinding || submitLock}
                    />
                </Form.Item>

                {/* ERP密码输入项 */}
                <Form.Item
                    key="form-password"
                    name="password"
                    label="ERP登录密码"
                    rules={[{ required: true, message: "请输入ERP登录密码" }]}
                    // 修复：禁用状态下不显示校验图标
                    hasFeedback={!isBinding && !submitLock}
                >
                    <Input
                        placeholder="请输入ERP登录密码"
                        type="password"
                        // size="large"
                        disabled={isBinding || submitLock}
                        // visibilityToggle={true} // 显示/隐藏密码
                    />
                </Form.Item>

                {/* 操作按钮区域 */}
                <Form.Item key="form-button" style={{ marginTop: 24 }}>
                    <Space size="large" style={{ width: "100%" }}>
                        {/* 取消按钮 */}
                        <Button
                            type="default"
                            onClick={handleCancel}
                            disabled={isBinding || submitLock}
                            style={{ flex: 1 }}
                        >
                            取消
                        </Button>

                        {/* 确认绑定按钮 */}
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isBinding || submitLock}
                            icon={isBinding || submitLock ? <LoadingOutlined /> : null}
                            style={{ flex: 1, backgroundColor: "#1890ff" }}
                        >
                            {isBinding || submitLock ? "绑定中..." : "确认绑定"}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default WechatBindModal;
